import { render } from "./app-link.vue?vue&type=template&id=1cc7070f&ts=true"
import script from "./app-link.vue?vue&type=script&lang=ts"
export * from "./app-link.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__